import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";


export const GetReportCertificateDetailById = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReportCertificate/GetDetail?` + params, null);

export const GetReportCertificateList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReportCertificate/GetList?` + params, null);

export const CreateReportCertificate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReportCertificate/Create`, data);

export const UpdateCertificate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReportCertificate/Update`, data);

export const DeleteCertificate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReportCertificate/Delete`, data);

export const GetPatientReportCertificatePreview = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReportCertificate/GetPatientReportPreview`, data);